import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { addCommitteeToPackage, removeCommitteeToPackage } from '../../../../../../services/committePackages.service';
import { getAllCommitteesFromAllPackages } from '../../../../../../services/committees.service';
import AddButton from '../../../../../Common/AddButton';
import { Select } from '../../../../../Common/Select';
import CommitteesList, { ICommittee } from '../../BoxLists/CommitteesList';
import { AddNewRelationContainer, CardInfo, SectionTitle, SelectContainer } from './styles';

interface ICommitteeFromPackageCardProps {
    actionShowSpinner: (state: boolean) => void;
    committeePackageId?: string;
    adminPackage?: boolean;
    onCommitteeListUpdated: (id: string) => Promise<void>;
    committees: ICommittee[];
}

const CommitteesFromPackageCard: React.FC<ICommitteeFromPackageCardProps> = ({
    committees, 
    actionShowSpinner, 
    adminPackage = false,
    committeePackageId, 
    onCommitteeListUpdated
}) => {  
    const [committeeListSelect, setCommitteeListSelect] = useState<{id: string; name: string}[]>([]);
    const [committeeSelectedToAdd, setCommitteeSelectedToAdd] = useState<{id: string; name: string} | null>(null);

    const committeeOptions = useMemo(() => {
        const committeesList = committeeListSelect as {id: string; name: string}[];

        return committeesList.filter((committee) => {
            return !committees.find((committeeAdded) => committeeAdded.id === committee.id);
        });
    }, [committeeListSelect, committees])

    useEffect(() => {
      const fetchCommitteesOptions = async() => {
        const {data, error} = await getAllCommitteesFromAllPackages()

        if(error || !data){
          return;
        }

        setCommitteeListSelect(data?.committees as {id: string; name: string}[]);
      }

      fetchCommitteesOptions();
    }, []);
        
    const handleAddCommittee = useCallback(async() => {
      if(!committeePackageId || !committeeSelectedToAdd) return;
      
      actionShowSpinner(true);
      
      try {
        await addCommitteeToPackage(committeePackageId, committeeSelectedToAdd.id);

        setCommitteeSelectedToAdd(null);
        onCommitteeListUpdated(committeePackageId);
      }catch(err) {
        // setToastMessage({
        //     autoHideDuration: 4000,
        //     content: 'Ocorreu um erro ao salvar',
        //     open: true,
        //     type: 'error'
        // })
      }
      
      actionShowSpinner(false);
    }, [committeePackageId, committeeSelectedToAdd]);    
        
    const handleRemoveCommittee = useCallback(async(committeeToDeleteId: string) => {
      if(!committeePackageId) return;
      
      actionShowSpinner(true);
      
      try {
        await removeCommitteeToPackage(committeePackageId, committeeToDeleteId);

        onCommitteeListUpdated(committeePackageId);
      }catch(err) {
        // setToastMessage({
        //     autoHideDuration: 4000,
        //     content: 'Ocorreu um erro ao salvar',
        //     open: true,
        //     type: 'error'
        // })
      }
      
      actionShowSpinner(false);
    }, [committeePackageId]);    
  
    return (
      <CardInfo elevation={1}>
        <SectionTitle>
          Comitês do Pacote
        </SectionTitle>

        <AddNewRelationContainer>
          <SelectContainer>
            <Select
              id="Committee"
              options={committeeOptions}
              value={committeeSelectedToAdd}
              setValue={(newValue: any) => {
                setCommitteeSelectedToAdd(newValue);
              }}
              label='Comitê'
            />
          </SelectContainer>

          <AddButton disabled={!committeePackageId || adminPackage} onClick={() => handleAddCommittee()} />
        </AddNewRelationContainer>

        <CommitteesList
          committees={committees} 
          handleRemoveCommittee={handleRemoveCommittee}
        />
      </CardInfo>   
    )
};

export default CommitteesFromPackageCard;
